<script lang="ts" setup>

    import { computed, onMounted, ref } from 'vue';
    import DatePickerNoTZ from '../../components/DatePickerNoTZ.vue';
    import { emrTemplate, IIntakeFilterModel } from '../../lib/ChoiceApi';
    import { IntakeFilterOption } from '../../Enums/ChoiceEnums'
    import { MessageSectionType, DisplayStyle } from '../../Enums/UiEnums'
    import { LoadingSection } from '../../LibMain';
    import  MessageSection from '../../components/Messages/MessageSection.vue'
    
    const props=withDefaults(defineProps<{templateId:number}>(), {templateId:0});
    const filter = ref<IIntakeFilterModel>({ filter_option: IntakeFilterOption.Always });
    const isLoadingValue=ref(true);
    const saving=ref(false);
    
    onMounted(async () => {
        filter.value = await emrTemplate.GetIntakeFilter(props.templateId);
        isLoadingValue.value = false;
    });

    async function SaveFilter()
    {     
        saving.value = true;
        await emrTemplate.saveIntakeFilter(filter.value!);
        saving.value = false;
    }

    function clearAllFilters()
    {
        clearIntervalFilter();
        clearDateFilter();
    }
    
    function clearIntervalFilter()
    {
        filter.value.last_encounter_time_interval = undefined;
        filter.value.last_encounter_time_unit = undefined;
    }

    function clearDateFilter()
    {
        filter.value.intake_specific_date = undefined;
    }

    const isValid = computed<boolean>(() => filter.value?.filter_option == IntakeFilterOption.Always || ((isIntervalValid.value) && (isIntervalUnitValid.value)) || isDateOptionValid.value);
    const isIntervalValid = computed<boolean>(() => 
        (filter.value?.filter_option == IntakeFilterOption.Interval &&
        (filter.value?.last_encounter_time_interval ?? -1) > 0));

    const isIntervalUnitValid = computed<boolean>(() => 
        (filter.value?.filter_option == IntakeFilterOption.Interval &&
        filter.value?.last_encounter_time_unit != undefined));

    const isDateOptionValid = computed<boolean>(() => 
        (filter.value?.filter_option == IntakeFilterOption.Date &&
        filter.value?.intake_specific_date != undefined));

     
</script>

<template>

<LoadingSection :isLoading="isLoadingValue" loadingMsg="Loading data...">
<div class="container" v-if="filter"> 
  <div class="row mb-4">
    <div class="col-4">
        <input class="form-check-input me-1" type="radio" :value="IntakeFilterOption.Always" v-model="filter.filter_option" v-on:click="clearAllFilters()">
        <label class="form-check-label" for="flexRadioDefault1">Always (Default)</label>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-8 col-sm-10 col-xs-12">
        <input class="form-check-input me-1" type="radio" :value="IntakeFilterOption.Interval" v-model="filter.filter_option" v-on:click="clearDateFilter()">
        <label class="form-check-label" for="flexRadioDefault1">Last Encounter Date (Mapped Template) Older Than:</label>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-2 col-sm-4 col-xs-6">
        <input type="number" class="form-control" placeholder="#" width="20" v-model="filter.last_encounter_time_interval" :disabled="filter.filter_option != IntakeFilterOption.Interval">
    </div>
    <div class="col-md-2 col-sm-4 col-xs-6" width="20">
        <select class="form-select" v-model="filter.last_encounter_time_unit" :disabled="filter.filter_option != IntakeFilterOption.Interval">
            <option value="D">Days</option>
            <option value="W">Weeks</option>
            <option value="M">Months</option>
        </select>
    </div>    
  </div>
  <div class="row mt-3" v-if="filter.filter_option == IntakeFilterOption.Interval">
        <MessageSection :show-icon="false" :type="MessageSectionType.Text" :display-style="DisplayStyle.Danger" v-if="!isIntervalValid">
            Interval number required
        </MessageSection>
        <MessageSection  :show-icon="false" :type="MessageSectionType.Text" :display-style="DisplayStyle.Danger" v-else-if="!isIntervalUnitValid">
            Interval Units required
        </MessageSection>
  </div>
  <div class="row mt-3">
    <div class="col-md-4">
        <input class="form-check-input me-1" type="radio" :value="IntakeFilterOption.Date" v-model="filter.filter_option" v-on:click="clearIntervalFilter()">
        <label class="form-check-label" for="flexRadioDefault1">After a specific date:</label>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-3 col-sm-4 col-xs-5">
        <DatePickerNoTZ :clearable="true" v-model="filter.intake_specific_date" :disabled="filter.filter_option != IntakeFilterOption.Date"/>
    </div>    
  </div>  
  <div class="row mt-3" v-if="filter.filter_option == IntakeFilterOption.Date">
    <MessageSection  :show-icon="false" :type="MessageSectionType.Text" :display-style="DisplayStyle.Danger" v-if="!isDateOptionValid">
        Date selection required
    </MessageSection>  
    </div>
  <div class="row mt-3">    
  </div>
  <div class="row mt-3">
    <div class="col-md-2 col-sm-4 col-xs-6">
        <button @click="SaveFilter()" class="btn btn-primary" type="button" :disabled="!isValid">
            Save                       
        <span v-show="saving" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </button>
    </div>
  </div>
</div>
</LoadingSection>

</template>